// https://gitlab.com/a2755/services/lead/-/blob/main/api/openapi.json?ref_type=heads

export enum Partner {
  KF = 'KF',
  StoreBrand = 'StoreBrand',
}

export interface Lead {
  ID: string;
  LoanApplicationID: string;
  CreatedAt: string;
  Sent: boolean;
  Partner: Partner;
}

export interface CreateLead {
  Partner: Partner;
  Consent: boolean;
}
